import React from 'react'
import { Link } from 'react-router-dom'

export const AccessForbidden = () => (
  <div>
    <h1>403</h1>
    <Link to={'/'}>Retour à l'accueil</Link>
  </div>
)
